import type {
  TValuesCurrentBlocks,
  TValuesCurrentHeatmapPoints,
  TValuesCurrentIrrigationZones,
  TValuesCurrentPoints,
  TValuesCurrentProperties,
  TValuesCurrentRegions,
} from 'App/Map/types'
import { mapControlsStore } from 'stores/mapControlsStore/mapControlsStore'
import type { MAP_VISUAL } from 'stores/mapControlsStore/types'
import type { TValueGroup } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'

type TPossibleValueTypes = TValuesCurrentPoints &
  TValuesCurrentBlocks &
  TValuesCurrentHeatmapPoints &
  TValuesCurrentProperties &
  TValuesCurrentRegions &
  TValuesCurrentIrrigationZones

export const getValueType = (
  mapVis: MAP_VISUAL,
  valueGroup: TValueGroup,
  isOutOfBlock = false,
): TValuesCurrentPoints &
  TValuesCurrentBlocks &
  TValuesCurrentHeatmapPoints &
  TValuesCurrentProperties &
  TValuesCurrentIrrigationZones => {
  const valueType = mapControlsStore.getState().mapVisualValueGroup[mapVis]?.[valueGroup]
    ?.valueType as TPossibleValueTypes

  if (isOutOfBlock) {
    return (
      (mapControlsStore.getState().mapVisualValueGroup[mapVis]?.[valueGroup]
        ?.outOfBlockValueType as TPossibleValueTypes) || valueType
    )
  }

  return valueType
}
